export function ChevronDown(props: any) {
  const { width = 24, height = 24, rotated = false, className = '' } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      transform={`${!rotated ? 'rotate(180)' : 'rotate(0)'}`}
      className={className}
      {...props}
    >
      <title>Chevron</title>
      <polyline fill="none" stroke="currentColor" strokeWidth="2" points="8 10 12 14 16 10" {...props} />
    </svg>
  )
}
